import { useEffect, useRef, useState } from 'react'

// import { REWARDS_TIME_THRESHOLD } from '../constants/app'
import { checkTimeBooster, getMinutesFromStartTime } from '../util/app.helpers'

const useSaleTimer = (saleEnded) => {
  const [firstMinutes, setFirstMinutes] = useState(getMinutesFromStartTime())

  const firstMinutesInterval = useRef(null)

  useEffect(() => {
    // if (!saleEnded && firstMinutes <= REWARDS_TIME_THRESHOLD.THIRD) {
    if (!saleEnded) {
      firstMinutesInterval.current = setInterval(
        () => setFirstMinutes(getMinutesFromStartTime()),
        1000
      )
    }
    return () => {
      clearFirstMinutesInterval()
    }
  }, [])

  useEffect(() => {
    // if (firstMinutes > REWARDS_TIME_THRESHOLD.THIRD) {
    if (firstMinutes <= 0) {
      clearFirstMinutesInterval()
    }
  }, [firstMinutes])

  const clearFirstMinutesInterval = () => {
    clearInterval(firstMinutesInterval.current)
  }

  const time = checkTimeBooster(firstMinutes)
  // return { ...time, diffMins: time.key - firstMinutes }
  return { ...time, diffMins: firstMinutes }
}

export default useSaleTimer
